import { render, staticRenderFns } from "./DoseDependentDuration.vue?vue&type=template&id=06cc4da9"
import script from "./DoseDependentDuration.vue?vue&type=script&lang=js"
export * from "./DoseDependentDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports